import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { PrivacyPage } from "./privacy";
import { LOCALIZED_LANGS, type Lang } from "../lib/i18n";

// /nl/privacy and its siblings were 404. The footer linked to them from every
// localised page, so a Dutch or Italian visitor who wanted to know what we hold
// about them hit a dead end. For a page whose entire job is transparency, that
// is the worst place on the site to have a broken link.
//
// The notice itself is still English; a machine-translated privacy policy is a
// liability, not a courtesy. What this route fixes is reachability, and the
// banner on the page says plainly which language governs.
export const Route = createFileRoute("/$locale/privacy")({
  beforeLoad: ({ params }) => {
    if (params.locale === "en") throw redirect({ to: "/privacy" });
    if (!LOCALIZED_LANGS.includes(params.locale as Lang)) throw notFound();
  },
  head: () => ({
    meta: [
      { title: "Privacy and your data | sunbedly" },
      {
        name: "description",
        content:
          "What data sunbedly holds about beach clubs and visitors, where it came from, why we hold it, and how to have it removed.",
      },
    ],
  }),
  component: PrivacyPage,
});
